// ─── 전화번호 원본 데이터 ─────────────────────────────
// 지역번호
export const AREA_PRE_CONSTANT = [
  '02',
  '031',
  '032',
  '033',
  '041',
  '042',
  '043',
  '044',
  '051',
  '052',
  '053',
  '054',
  '055',
  '061',
  '062',
  '063',
  '064',
  '070',
]

// 휴대폰 번호
export const MBL_PRE_CONSTANT = ['010', '011', '016', '017', '018', '019']

// ─── Select 옵션 헬퍼 ─────────────────────────────────
/** 문자열 배열 → { value, label } 옵션 배열로 변환 */
const toOptions = (arr) => arr.map((v) => ({ value: v, label: v }))

/**
 * 전화번호(지역번호 + 휴대폰) 전체 Select 옵션
 * - placeholder '선택' 포함
 * - 휴대폰(010) + 지역번호(02~070) 순서
 */
export const PHONE_NUMBER_OPTIONS = [
  { value: '', label: '선택' },
  ...toOptions(MBL_PRE_CONSTANT),
  ...toOptions(AREA_PRE_CONSTANT),
]

/**
 * 지역번호만 Select 옵션 (유선전화/FAX용)
 * - placeholder '선택' 포함
 */
export const AREA_NUMBER_OPTIONS = [
  { value: '', label: '선택' },
  ...toOptions(AREA_PRE_CONSTANT),
]

/**
 * 휴대폰 번호만 Select 옵션
 * - placeholder '선택' 포함
 */
export const MOBILE_NUMBER_OPTIONS = [
  { value: '', label: '선택' },
  ...toOptions(MBL_PRE_CONSTANT),
]


